import React from 'react';
import type { TableComponentProps } from './types';

// Pure function handler for footer showing count
/**
 * Renders the row-range caption below a paginated table. Treats result sets of nine or fewer rows as a single page starting at row one, otherwise derives the range from the current page and page size capped at the data length, and emits the caption only when a ticket count or total exists.
 *
 * @param params - The current page rows, page index and size, and the ticket count or overall total.
 * @returns The showing-count span, or null when no total is available.
 */
export function showingCountPage(
  params: Pick<TableComponentProps, 'data' | 'currentPage' | 'pageSize' | 'ticketCount' | 'total'>,
): React.JSX.Element | null {
  const currentPage = params.currentPage ?? 1;
  const pageSize = params.pageSize ?? 0;
  const startRowIndex = params.data?.length <= 9 ? 1 : (currentPage - 1) * pageSize + 1;
  const endRowIndex =
    params.data?.length <= 9
      ? params.data?.length
      : Math.min(currentPage * pageSize, params.data.length);

  return params.ticketCount || params.total ? (
    <span className="show-count-page">
      {`Showing ${startRowIndex}-${endRowIndex} of ${params.ticketCount || params.total}`}
    </span>
  ) : null;
}
